// constants related to tracking user events
/* eslint-disable import/prefer-default-export */
export enum UserEventType {
  UNSPECIFIED = 'unspecified',
  BUTTON_CLICK = 'button_click',
  PAGE_VISIT = 'page_visit',
  LINK_CLICK = 'link_click',
  ICON_BUTTON_CLICK = 'icon_button_click',
  ACCORDION_CLICK = 'accordion_click',
  PAGE_DURATION = 'page_duration',
  PAGE_DEPTH = 'page_depth',
  TAB_CLICK = 'tab_click',
  TEXT_FIELD_CLICK = 'text_field_click',
  DOCUMENT_DURATION = 'document_duration',
}
